import { Component } from 'preact'

import Input from 'app/components/Input'
import Button from 'app/components/Button'
import Form from 'app/components/Form'
import { api } from 'app/util/api'
import { route } from 'preact-router'
import linkState from 'linkstate'

export default class Submit extends Component {
  state = {
    url: '',
    title: '',
  }

  componentDidMount() {
    this.setState({ url: this.props['u'], title: this.props['amp;t'] })
  }

  addBookmark = async () => {
    const { url, title } = this.state

    await api.post('/bookmark', { url, title })

    route('/')
  }

  render() {
    const { url, title } = this.state

    return (
      <div>
        <div className="row">
          <div className="col">
            <h2 class="font-weight-bold">Submit</h2>
            <div class="mb-4 text-muted">You can also submit via bookmarklet</div>

            <Form onSubmit={this.addBookmark}>
              <Input
                class="w-50 mx-auto mb-4"
                onInput={linkState(this, 'url')}
                value={url}
                label="URL"
                required
              />
              <Input
                class="w-50 mx-auto mb-4"
                onInput={linkState(this, 'title')}
                value={title}
                label="Title"
                optional
              />
              <Button type="submit">Submit</Button>
            </Form>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./pages/Submit.js